/**
 * Removes an input's error message element
 *
 * @param {Event} event: the event for the input to remove the error for
 */
const hideInputErrorField = (event) => {
  const input = event.target;
  const inputName = input.getAttribute('name');
  const inputErrorEl = document.querySelector(`[data-error-for="${inputName}"]`) || false;
  if (inputErrorEl) inputErrorEl.parentNode.removeChild(inputErrorEl);
};

/**
 * Display an error message for an input with an invalid value
 *
 * @param {Event} event: the event for the the input to add an error for
 */
const addInputErrorField = (event) => {
  // ensure we don't duplicate the error field
  hideInputErrorField(event);
  // build the error
  const input = event.target;
  const inputName = input.getAttribute('name');
  const inputErrorMessage = input.getAttribute('data-error-message');
  const errorMessageEl = document.createElement('p');
  errorMessageEl.classList.add('input-error');
  errorMessageEl.setAttribute('data-error-for', inputName);
  errorMessageEl.innerHTML = inputErrorMessage;
  input.parentNode.appendChild(errorMessageEl);
};

/**
 * Add validation to form inputs
 *
 * @param {Array} inputs: array of inputs to add validation to
 */
const addFormValidation = (inputs) => {
  inputs.forEach((input) => {
    input.addEventListener('invalid', addInputErrorField);
    input.addEventListener('change', hideInputErrorField);
  });
};

export default {
  addFormValidation,
};
